import { useState, useEffect } from "react";
import { Trash2, Check, AlignLeft, AlignCenter, AlignRight, Maximize2 } from "lucide-react";
import FloatingBubble from "../FloatingBubble";
import "./Bubbles.css";

const ALIGN = [
  { key: "left", icon: AlignLeft, style: { float: "left", margin: "0 12px 8px 0", display: "" } },
  { key: "center", icon: AlignCenter, style: { float: "", margin: "0 auto", display: "block" } },
  { key: "right", icon: AlignRight, style: { float: "right", margin: "0 0 8px 12px", display: "" } },
  { key: "full", icon: Maximize2, style: { float: "", margin: "8px 0", display: "block", width: "100%" } },
];

export default function ImageBubble({ anchorEl, iframeEl, onClose, onChange }) {
  const [url, setUrl] = useState(anchorEl.getAttribute("src") || "");
  const [alt, setAlt] = useState(anchorEl.getAttribute("alt") || "");
  const [width, setWidth] = useState(anchorEl.style.width || "");
  const [unit, setUnit] = useState((anchorEl.style.width || "").endsWith("%") ? "%" : "px");

  useEffect(() => {
    setUrl(anchorEl.getAttribute("src") || "");
    setAlt(anchorEl.getAttribute("alt") || "");
    setWidth(anchorEl.style.width || "");
  }, [anchorEl]);

  const commit = (mutator) => { mutator(); onChange(); };

  const apply = () => {
    commit(() => {
      anchorEl.setAttribute("src", url);
      anchorEl.setAttribute("alt", alt);
      const w = width.toString().replace(/[^\d]/g, "");
      anchorEl.style.width = w ? `${w}${unit}` : "";
    });
    onClose();
  };

  const applyAlign = (a) => {
    commit(() => {
      anchorEl.style.float = a.style.float;
      anchorEl.style.margin = a.style.margin;
      anchorEl.style.display = a.style.display || "";
      if (a.key === "full") { anchorEl.style.width = "100%"; setWidth("100"); setUnit("%"); }
    });
  };

  const del = () => {
    commit(() => anchorEl.parentNode?.removeChild(anchorEl));
    onClose();
  };

  return (
    <FloatingBubble anchorEl={anchorEl} iframeEl={iframeEl} label="Image" onClose={onClose}>
      <div className="bubble-field">
        <label>Image URL</label>
        <input type="text" value={url} onChange={(e) => setUrl(e.target.value)} />
      </div>
      <div className="bubble-field">
        <label>Alt text</label>
        <input type="text" value={alt} onChange={(e) => setAlt(e.target.value)} />
      </div>
      <div className="bubble-row">
        <div className="bubble-field" style={{ flex: 1 }}>
          <label>Width</label>
          <input
            type="number"
            value={width.toString().replace(/[^\d]/g, "")}
            onChange={(e) => setWidth(e.target.value)}
          />
        </div>
        <div className="bubble-field">
          <label>Unit</label>
          <select value={unit} onChange={(e) => setUnit(e.target.value)}
            style={{ height: 30, border: "1px solid #e2e8f0", borderRadius: 6, padding: "0 8px" }}>
            <option value="px">px</option>
            <option value="%">%</option>
          </select>
        </div>
      </div>
      <div className="bubble-row" style={{ gap: 4 }}>
        {ALIGN.map((a) => {
          const Icon = a.icon;
          return (
            <button key={a.key} type="button" className="bubble-btn icon-only" onClick={() => applyAlign(a)} title={a.key}>
              <Icon size={13} />
            </button>
          );
        })}
      </div>
      <div className="bubble-actions">
        <button type="button" className="bubble-btn primary" onClick={apply}><Check size={12} /> Apply</button>
        <button type="button" className="bubble-btn danger" onClick={del}><Trash2 size={12} /> Delete</button>
      </div>
    </FloatingBubble>
  );
}
